module.exports = __webpack_public_path__ + "img/rondintermauve.f84b3a91.svg";